import { useState, useCallback, useEffect } from 'react';
import { FruitType, useAppContext } from '../context';

interface AudioTrack {
    audio: HTMLAudioElement;
    duration: number;
}

const FEMALE_STAGES: Record<FruitType, number> = {
    mango: 4,
    milk: 1,
    roll: 4,
};

export const usebubnezSound = (fruitType: FruitType) => {
    const [bubnezSounds, setbubnezSounds] = useState<AudioTrack[]>([]);
    const { musicPlay } = useAppContext();
    useEffect(() => {
        const loadSounds = async () => {
            try {
                const sounds = await Promise.all(
                    Array.from({ length: 5 }, async (_, index) => {
                        const audio = new Audio(`/sounds/bu${index + 1}.mp3`);
                        audio.volume = 0.15;

                        return new Promise<AudioTrack>((resolve) => {
                            audio.addEventListener("loadedmetadata", () => {
                                resolve({
                                    audio,
                                    duration: audio.duration * 1000,
                                });
                            });
                            audio.addEventListener("error", () => {
                                resolve({
                                    audio,
                                    duration: 1000,
                                });
                            });
                        });
                    })
                );

                setbubnezSounds(sounds);
            } catch (error) {
                console.error("Failed to load bubnej sounds:", error);
            }
        };

        loadSounds();
    }, [fruitType]);

    const playbubnezSound = useCallback((stage: number) => {
        if (!bubnezSounds.length || !musicPlay) return;

        const isFemaleStage = FEMALE_STAGES[fruitType] === stage;

        if (isFemaleStage) {
            const femaleSound = bubnezSounds[4];
            femaleSound.audio.currentTime = 0;
            return femaleSound.audio
                .play()
                .catch((error) => console.error("Failed to play female bubnej sound:", error));
        }

        const maleIndex = Array.from({ length: stage }, (_, i) => i + 1)
            .filter(s => FEMALE_STAGES[fruitType] !== s)
            .indexOf(stage);

        const sound = bubnezSounds[maleIndex];
        if (!sound) return;

        sound.audio.currentTime = 0;
        return sound.audio
            .play()
            .catch((error) => console.error("Failed to play bubnej sound:", error));
    }, [bubnezSounds, fruitType, musicPlay]);

    return { playbubnezSound };
};